import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "@/helpers/axios";
import type { ApiResponse } from "@/helpers/axios";
import { useIssuesStore } from "../_store/useIssues.store";
import { IssuesMeta, IssuesQueryData } from "../_types/issues.types";

const FALLBACK_META: IssuesMeta = {
  total: 0,
  page: 1,
  limit: 10,
  totalPages: 1,
};

export const useIssuesQuery = () => {
  const type = useIssuesStore((state) => state.type);
  const period = useIssuesStore((state) => state.period);
  const status = useIssuesStore((state) => state.status);
  const page = useIssuesStore((state) => state.page);
  const limit = useIssuesStore((state) => state.limit);

  return useQuery({
    queryKey: ["issues", type, period, status, page, limit],
    queryFn: async (): Promise<IssuesQueryData> => {
      const response = await axiosInstance.get<ApiResponse<IssuesQueryData["items"], IssuesMeta>>(
        "/v2/issues",
        {
          params: {
            type,
            period,
            status,
            page,
            limit,
          },
        }
      );

      return {
        items: response.data.data ?? [],
        meta: response.data.meta ?? {
          ...FALLBACK_META,
          page,
          limit,
        },
      };
    },
    placeholderData: (previousData) => previousData,
  });
};
